import React from 'react'
import ErrorBoundary from './ErrorBoundary'

interface WithErrorBoundaryProps {
  fallback?: React.ComponentType<{ error?: Error }>
}

export function withErrorBoundary<P extends object>(
  Component: React.ComponentType<P>,
  { fallback }: WithErrorBoundaryProps = {}
) {
  const WrappedComponent = (props: P) => (
    <ErrorBoundary fallback={fallback}>
      <Component {...props} />
    </ErrorBoundary>
  )

  WrappedComponent.displayName = `withErrorBoundary(${Component.displayName || Component.name})`

  return WrappedComponent
}

export default withErrorBoundary
